import _ from 'underscore';

import type AuthoringCourseBranch from 'bundles/author-branches/models/AuthoringCourseBranch';
import ContextStatusStates from 'bundles/author-course-level/constants/ContextStatusStates';
import { isPrivateContext } from 'bundles/author-course-level/utils/contextUtils';
import type { AuthoringCourseContextInformation } from 'bundles/authoring/common/types/authoringCourseContexts';
import type { FlagCategory } from 'bundles/authoring/course-content-feedback/types/courseContentFeedback';
import type { Category } from 'bundles/content-feedback/constants/ItemFlagCategories';
import itemFlagCategories from 'bundles/content-feedback/constants/ItemFlagCategories';

import type { ItemType } from '../constants/ItemTypes';

/**
 * Returns the visible flag categories to the current user.
 * @param itemType Item Type (optional). If not present, return categories across all items
 * @return Array of supported categories.
 */
export const getVisibleFlagCategories = (itemType: ItemType, isSuperuser: boolean) => {
  let categories;
  const categoryConstants = itemFlagCategories();

  if (itemType) {
    categories = categoryConstants[itemType];
  } else {
    categories = _(categoryConstants)
      .chain()
      .values()
      .flatten()
      .uniq((category) => category.id)
      .value();
  }

  let visibleCategories: Array<FlagCategory> = [];

  if (isSuperuser) {
    visibleCategories = categories;
  } else {
    visibleCategories = _(categories).filter((category) => category.isPublic);
  }

  return visibleCategories;
};

export const canViewItemFeedback = (
  courseContext?: AuthoringCourseContextInformation,
  authoringBranch?: AuthoringCourseBranch
): boolean => {
  if (courseContext && isPrivateContext(courseContext.typeName)) {
    return !([ContextStatusStates.NEW, ContextStatusStates.UPCOMING, ContextStatusStates.PENDING] as string[]).includes(
      courseContext.status
    );
  } else {
    return authoringBranch?.isLaunched || authoringBranch?.isBaseBranch || false;
  }
};

export const getCategoriesForLearnerItemType = (itemTypeName: ItemType) => {
  const categoryConstants = itemFlagCategories();

  const categories: Category[] = categoryConstants[itemTypeName];

  return categories;
};
